import { render } from "./Enrolled.vue?vue&type=template&id=260ec080"
import script from "./Enrolled.vue?vue&type=script&lang=js"
export * from "./Enrolled.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__